export enum ObjectForDataSource{
    Template,
    NewObject
}